import { CCardFooter } from "@coreui/react";
import { Box, Button, Card, CardContent, CardHeader, Divider, IconButton, MenuItem, Select, SelectChangeEvent, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import {AttachFile, Delete} from '@mui/icons-material'
import { T_Inquery } from "../../common/model/InqueryModel";
import apis from "../../common/apis";
import { initialAlert, useAlert } from "../../provider/AlertContextProvider";
import { T_Trouble } from "../../common/model/troubleModel";
import { T_Code } from "../../common/model/codeModel";
export default function TroubleEdit(){
    const { state } = useLocation();
    // state.inqueryData 에서 넘어온 item 객체를 꺼낼 수 있습니다.
    const idata = state?.item;

    const nav = useNavigate();
    const [cstatus ,setCstatus] = useState('0');
    const [data,setData] = useState<T_Trouble>(idata);
    const {alert,setAlert} = useAlert();

    const handleChange = (event: SelectChangeEvent) => {
      setCstatus(event.target.value);
      };
      const [selectedFiles, setSelectedFiles] = useState<File[]>([])

      const handleFileChange = (
        event: React.ChangeEvent<HTMLInputElement>,
      ) => {
        if (!event.target.files) return
        setSelectedFiles(Array.from(event.target.files))
      }    

      const handleRemoveFile = (index: number) => {
        setSelectedFiles(prev =>
          prev.filter((_, i) => i !== index)
        )
      }

      const saveData = async()=>{

        if(data.title === "" || data.title === undefined){
            setAlert({...alert,visible:true,title:"확인",msg:"제목을 입력하여 주십시요"})   
            return;
        }
        if(data.contents == "" || data.contents === undefined){
            setAlert({...alert,visible:true,title:"확인",msg:"내용을 입력하여 주십시요"})   
            return;
        }
         
        setAlert({...alert,title:"확인",msg:"정말로 수정 하시겠습니가?",visible:true,buttonList:[
            {
                text:"예"
                ,variant:"contained"
                ,onPress:async()=>{
                         // prev.files만 분리, 나머지는 rest에
                      const { files, ...payload } = data

                    const result = await apis.trouble.troubleCreate({...payload,filelist:selectedFiles})   
                    console.log("result:",result);
                    if(result.code=="1"){
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"수정이 완료되었습니다."})
                        nav("/trouble")
                    }else{
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"수정중 오류가 발생했습니다.."})
                    }
           
                }
            },{
                text:"아니요"
                ,variant:"outlined"
                ,onPress:()=>{
                    setAlert(initialAlert);
                }
            }
        ]})


      }

    const [typeList,setTypeList] = useState<T_Code[]>();
    const [gubunList,setGubunList] = useState<T_Code[]>();

      const getCodeList = async()=>{
        const result = await apis.code.codeList({pCode:"type"})
        console.log(result)
        if(result.code=="1"){
           setTypeList(result.data.list);
  //         setData({...data,type:result.data.list[0].code})
        }
     }   
        const getGubunList = async()=>{
      const result = await apis.code.codeList({pCode:"gubun"})
      console.log(result)
      if(result.code=="1"){
         setGubunList(result.data.list);
//         setData({...data,type:result.data.list[0].code})
      }
   }   
  
     useEffect(()=>{
        getCodeList();
        getGubunList();
     },[])

     const handleDeleteFile = (index:number,name:string) => { // 실제 DB FILE 삭제
          setAlert({...alert,visible:true,title:"확인",msg:name+" 해당파일을 정말로 삭제하시겠습니까?",buttonList:[{text:"예",onPress:async()=>{
            const result = await apis.common.fileDelete({idx:index})
            if(result.code=="1"){
//              setAlert({...alert,visible:true,msg:"삭제 되었습니다."})
              setAlert(initialAlert);
              getData();
            }

          }
          },{text:"아니요",onPress:()=>{
            setAlert(initialAlert);
          }}]})
      }

      const getData = async()=>{
         const result = await apis.trouble.troubleInfo({idx:data.idx})
         console.log("info:",result)
         if(result.code=="1"){
            setData(result.data);
         }
      }


    return(
     <>
    <Card >
        <CardHeader title="트러블슈팅 수정" sx={{pb:0,mb:0}}/>
        <CardContent>
            <Divider />
        <Table  stickyHeader aria-label="sticky table"  sx={{borderTopWidth:2
          }} > 
            <TableHead />
            <TableBody>
            <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          구분
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={data.gubun}
                            onChange={(event:SelectChangeEvent)=>{
                              setData({...data,gubun:event.target.value})
                            }}
                            size="small"
                        >
                             { gubunList && gubunList.map((item,idx)=>{
                              return(<MenuItem value={item.name}>{item.name}</MenuItem>)
                            })}
                        </Select>
                        </TableCell>      
                        <TableCell component="th" scope="row" sx={{width:150}}>
                          항목
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={data.type}
                            onChange={(event:SelectChangeEvent)=>{
                              setData({...data,type:event.target.value});
                            }}
                            size="small"
                        >
                            { typeList && typeList.map((item,idx)=>{
                              return(<MenuItem value={item.name}>{item.name}</MenuItem>)
                            })}
                        </Select>

                        </TableCell>                         

          </TableRow>        
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          에러코드
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                        <TextField  size="small" fullWidth value={data.errcode || ''} onChange={(event)=>{setData({...data,errcode:event.target.value})}} />
                        </TableCell>      

        </TableRow>          

        <TableRow>          
        <TableCell component="th" scope="row" sx={{width:150}}>
                          문의내용
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                          <TextField multiline
                            rows={10}
                            fullWidth 
                            value={data.contents || ''} onChange={(event)=>{setData({...data,contents:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>          
        <TableRow>          
                        <TableCell component="th" scope="row" sx={{width:150}}>
                          처리방법
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                          <TextField multiline
                            rows={10}
                            fullWidth 
                            value={data.pmethod || ''} onChange={(event)=>{setData({...data,pmethod:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>   
        {/* <TableRow>  
                       <TableCell component="th" scope="row" sx={{width:150}}>
                          비고
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                          <TextField multiline
                            rows={10}
                            fullWidth 
                            value={data. || ''} onChange={(event)=>{setData({...data,contents:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>             */}
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          파일첨부
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                        <Button
                        variant="contained"
                        component="label"
                        startIcon={<AttachFile />}
                        >
                        파일 선택
                        <input
                            type="file"
                            hidden
                            multiple                        // 여러 파일 선택허용
                            onChange={handleFileChange}
                        />
                        </Button>
                         {selectedFiles.length == 0 && data.files?.map((fileitem,idx)=>{
                            return(<Box  
                                  key={idx}
                                 sx={{
                                 display: 'flex',
                                 alignItems: 'center',
                                 mt: 0.5,
                               }}><Typography>{fileitem.fileOrgNm}</Typography>
                            <IconButton
                            size="small"
                            onClick={() => fileitem.fileOrgNm && handleDeleteFile(fileitem.idx,fileitem.fileOrgNm)}
                            >
                            <Delete fontSize="small" />
                            </IconButton>       
                            </Box>
                            )
                        })}
                                          {/* 선택된 파일명 리스트 */}
                        {selectedFiles.length > 0 && (
                        <Box mt={1}>
                            {selectedFiles.map((file, idx) => (
                               <Box
                               key={idx}
                               sx={{
                                 display: 'flex',
                                 alignItems: 'center',
                                 mt: 0.5,
                               }}
                             >    
                            <Typography
                                variant="body2"
                                key={idx}
                            >
                                {file.name}
                            </Typography>
                            <IconButton
                            size="small"
                            onClick={() => handleRemoveFile(idx)}
                            >
                            <Delete fontSize="small" />
                            </IconButton>
                          </Box>
                            ))}
                        </Box>
                        )}                            
                        </TableCell>      

        </TableRow>        
        </TableBody>

        </Table>

        </CardContent>
        <CCardFooter style={{   display: 'flex',justifyContent:'center',textAlign:'center',paddingBottom:10, gap: '1rem'}}  >
        <Button variant="contained" onClick={()=>{
          saveData();
          }}>수정완료</Button>
        <Button variant="outlined" onClick={()=>{
        nav(-1);
         }}>취소</Button>

        </CCardFooter>
    </Card>

    </>)
}